/* Indiehouse K4 — delegate for Ajax-loaded collection cards. */
(() => {
  if (window.__ihSizeAddReady) return;
  window.__ihSizeAddReady = true;
  document.addEventListener('click', async event => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const button = target?.closest('[data-ih-size-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.dataset.loading === 'true') return;
    const id = Number(button.dataset.variantId);
    if (!Number.isSafeInteger(id) || id <= 0) return;
    const status = button.closest('.ih-k4-size-choices')?.querySelector('.ih-k4-status');
    const root = window.Shopify?.routes?.root || '/';
    button.dataset.loading = 'true';
    button.setAttribute('aria-busy','true');
    if(status) status.textContent = 'Adding…';
    try {
      const response = await fetch(root + 'cart/add.js',{
        method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id,quantity:1}],sections:['cart-drawer'],sections_url:location.pathname+location.search})
      });
      if(!response.ok){
        const e = await response.json().catch(()=>null);
        throw new Error(e?.description || 'Could not add this size');
      }
      const added = await response.json();
      const cartResult = await fetch(root+'cart.js',{credentials:'same-origin'});
      if(!cartResult.ok) throw new Error('Cart refresh failed');
      const cart = await cartResult.json();
      const current = document.querySelector('#cart-drawer');
      const html = added.sections?.['cart-drawer'];
      if(current && html){
        const incoming = new DOMParser().parseFromString(html,'text/html').querySelector('#cart-drawer');
        if(incoming){
          current.innerHTML=incoming.innerHTML;
          current.className=incoming.className;
          current.setAttribute('data-cart-has-discount',incoming.getAttribute('data-cart-has-discount')||'false');
        }
      }
      document.querySelectorAll('cart-count').forEach(el=>{el.textContent=cart.item_count});
      document.querySelectorAll('cart-dot').forEach(el=>el.classList.toggle('is-visible',cart.item_count>0));
      document.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart}}));
      if(status) status.textContent='Added to bag';
    }catch(error){
      if(status) status.textContent=error.message||'Please try again';
    }finally{
      button.dataset.loading='false';
      button.removeAttribute('aria-busy');
    }
  },true);
})();
